/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { startProgress, stopProgress } from './progress-util.js';
import { postToBackend } from './fetch-util.js';



export function queryListMediaIDs( list_id, callback ) {
	startProgress();
	postToBackend( 'json/media/list-getallmids', 'list_id='+encodeURIComponent(list_id)+'&filter_deleted=1', function(j) {
		stopProgress();
		if( j ) callback( j.media_ids, j.result_count );
	} );
}



